import directives from './directives'

const importDirective = Vue => {

  /**
   * 拖拽指令 v-draggable = "options"
   * options = {
   *   trigger: /拖拽触发器的css选择器
   *   body: /移动容器的css选择器
   *   recover: /是否恢复到原来的位置
   * }
   */
  Vue.directive('draggable',directives.draggable)
  Vue.directive('clickoutside',directives.clickoutside)
  Vue.directive('selectBlur',directives.selectBlur)
}

export default importDirective



// WEBPACK FOOTER //
// ./src/directive/index.js